import type { BackgroundChats } from "./server-event-scheduler"

/**
 * This tab's background chats: mounted, but not where the user is looking.
 * Grid Mode sets them; every machine's event scheduler reads them.
 */
let sessionIDs: ReadonlySet<string> = new Set()
let revision = 0
const listeners = new Set<() => void>()

export const backgroundChats: BackgroundChats = {
  revision: () => revision,
  has: (sessionID) => sessionIDs.has(sessionID),
}

export function setBackgroundChats(ids: Iterable<string>) {
  const next = new Set(ids)
  if (next.size === sessionIDs.size && [...next].every((id) => sessionIDs.has(id))) return
  sessionIDs = next
  revision += 1
  for (const listener of listeners) listener()
}

export function onBackgroundChatsChange(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
